export default __webpack_public_path__ + "static/living-room-property-management-92ef3a62ce8b6d7ecacb9cf90cd2af4e.png";